var exports = {
  "wp": "DurationContainer__IsIxI8",
  "Vx": "QuantityInputContainer__oixApL",
  "M1": "QuantityInput__npjZuQ",
  "$D": "Error__Nx6pzc",
  "J2": "UnitsButtonCompact__N0Z_5K",
  "ae": "UnitsButton__yW4Dk4",
  "ZD": "UnitsText__nGmImD",
};

module.exports = exports;
